import { AmountType, CalculateByField } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionDescriptor } from "../../../../../../../../../api/types/svTypes.ts";
import { toAmountCalculateByCaption } from "../../customMeasure/utilities/measureConverter";

const AMOUNT_DIMENSION_TO_FIELD: Record<string, { calcBy: CalculateByField; amountType: AmountType }> = {
  AmountLcy: { calcBy: CalculateByField.Lcy, amountType: AmountType.Net },
  CreditLcy: { calcBy: CalculateByField.Lcy, amountType: AmountType.Credit },
  DebitLcy: { calcBy: CalculateByField.Lcy, amountType: AmountType.Debit },
  AmountPcy: { calcBy: CalculateByField.Pcy, amountType: AmountType.Net },
  CreditPcy: { calcBy: CalculateByField.Pcy, amountType: AmountType.Credit },
  DebitPcy: { calcBy: CalculateByField.Pcy, amountType: AmountType.Debit },
  AmountScy: { calcBy: CalculateByField.Scy, amountType: AmountType.Net },
  AdditionalAmountLcy: { calcBy: CalculateByField.AdditionalLcy, amountType: AmountType.Net },
  AdditionalCreditLcy: { calcBy: CalculateByField.AdditionalLcy, amountType: AmountType.Credit },
  AdditionalDebitLcy: { calcBy: CalculateByField.AdditionalLcy, amountType: AmountType.Debit },
  Shares: { calcBy: CalculateByField.Shares, amountType: AmountType.Net },
};

export const getSourceColumnCaption = (field: string, dimensions: DimensionDescriptor[]): string => {
  const mapping = AMOUNT_DIMENSION_TO_FIELD[field];
  if (mapping) {
    return toAmountCalculateByCaption(mapping.calcBy, mapping.amountType);
  }
  return dimensions.find((d) => d.name === field)?.caption ?? field;
};
